export default {
  icon: 'open_in_browser',
  name: 'Actions',
  title: 'Actions',
  action: 'Action',
  actionplan: "Plan d'actions",
  notFinished: 'Actions non terminées',
  noItems:
    "Il n'y a pas encore d'action en relation avec l'organisation et les filtres sélectionnés",
  startDiff: `Débute dans {days} jours`,
  started: `Débuté`,
  ended: `Expiré`,
  noGain: 'Pas de gain',
  endDiff: `Expire dans {days} jours`,
  deadlines: 'Echéances',
  tabs: {
    user_exchanges: 'Echanges',
    infos: 'Infos',
    description: 'Description',
    earnings: 'Gains',
  },
  fields: {
    authors: 'Auteurs',
    description: 'Description',
    id: 'ID',
    node_id: 'Node ID',
    current_action_status_type_id: 'Etat',
    type_id: 'Type',
    entity_id: 'Equipe',
    gain_value: 'Gain',
    creation_datetime: 'Date de création',
    start_datetime: 'Date de début',
    end_datetime: 'Date de cloture',
    code: 'Code installation',
    shortname: 'Nom court',
    on_site: 'Sur site',
    node_associated_code: 'Code installation',
    node_associated_name: 'Installation',
    deadline_datetime: 'Date limite de réalisation',
    node_associated_shortname: 'Nom court',
    node_associated_nav_full_id: 'Nav_full_id',
    type_name: 'Type',
    priority_id: 'Priorité',
    author_name: 'Auteur',
    priority_name: 'Priorité',
    market_type: 'Type de marché',
    persons_in_charge: 'Personnes en charge',
    current_action_plan_status_datetime: 'Date de modification',
    current_act_status_type_name: 'Etat',
    staffs_in_charge_id: 'Personnes en charge',
    author_id: 'Auteur',
    customer_shared_description: 'Description PDF visible client',
    daybook: 'Main Courante',
  },
  create: {
    authors: 'Personnes en charge',
    authorType: 'Groupe',
    btnText: 'Ajouter une action',
    consumption_calculation: "Lancer un calcul d'écart de consommation",
    deadline_datetime: 'Date limite de réalisation',
    description: 'Description',
    entity: 'Equipe',
    icon: 'add',
    mail: {
      send: "Envoi d'un mail",
      error: `La description de l'action ou du plan d'action est trop longue et a été raccourcie, vous pouvez la copier/coller manuellement dans votre mail`,
    },
    nodt_date: 'Date de début requise',
    notype: 'Type requis',
    nopriority: 'Priorité requise',
    noproperty: 'Installation requise',
    onsite_intervention: 'Intervention sur site',
    priorities: 'Priorité',
    properties: 'Installation',
    start_date: 'Date de début *',
    title: 'Ajouter une action',
    type: 'Type',
    validate: 'Créer',
    customer_shared_description: 'Description PDF visible client',
    daybook: 'Main Courante',
    daybook_forced: 'Forcer renvoi Main Courante',
    daybook_hover: 'Main Courante (Visible CLIENT)',
    no_person_in_charge: 'Veuillez ajouter une personne en charge',
  },
  update: {
    icon: 'edit',
    btnText: '',
    validate: 'Mettre à jour',
    title: "Modifier l'action",
  },
  delete: {
    validate: 'Supprimer cette action ?',
    title: "Supprimer l'action",
    icon: 'delete',
  },
  item: {
    noItems: 'Action introuvable',
    link: "Lien vers l'action",
  },
  gain: {
    mwh: 'MWh PCI',
    waitingGain: 'En attente',
    waitingDate: 'Date prévisionnelle',
    waitingIcon: 'pending',
    manualGain: 'Gain Saisie manuelle',
    resultsGain: 'Gain Calculé',
    co2GainIcon: 'cloud',
    co2GainUnit: 't CO₂',
    forcastDateLabel: 'Date prévisionelle',
    commentLabel: 'Commentaire *',
    gainTypeLabel: 'Type de gain',
    unitTypeLabel: 'Unité *',
    valueLabel: 'Gain *',
    unitRelativeTypeLabel: '%',
    valueRelativeLabel: 'Gain relatif *',
    noGainBtn: 'Pas de gain',
    noGainText: 'PAS DE GAIN',
    noGainIcon: 'close',
    firstDate: 'Référence',
    secondDate: 'Cible',
    date: 'date',
    reset: 'réinitialiser',
    updateValue: `La valeur calculée aujourd'hui à partir des dates enregistrées ne correspond pas à la valeur enregistrée.
      Cliquer pour utiliser la nouvelle valeur.`,
    save: 'Valider',
    saved: 'Validé',
    cancel: 'Annuler modifications',
    cumulated: 'Cumulé',
    nodata: 'Aucune relève calculée',
    refDate: 'Période référence',
    targetDate: 'Période cible',
    waiting: 'En attente',
    snackbarMessageStart:
      'Votre choix de réaliser un calcul de gain à la date prévisionnelle du ',
    snackbarMessageEnd: ' a été pris en compte',
    marketTypeF: 'Type Forfait',
    marketTypeMC: 'Type Marché comptage',
    marketTypeMCI: 'Type Marche comptage interessement',
    graph: {
      title:
        'La  sélection  des  données  pour  le calcul  de  gain  se  fait  en  cliquant directement sur le graphe.',
      step1: '1er clic : Données de référence',
      step2: '2ème clic : Données réel',
    },
    instruction: {
      title:
        'Vous pouvez choisir entre trois actions situés dans les trois zones ci-contre :',
      possibility1:
        'Ajouter une date prévisionnelle pour calculer le gain plus tard',
      possibility2: "Ne pas remplir de gain si cette action n'en a pas",
      possibility3: 'Enregistrer un gain pour cette action',
    },
  },
};
